import isArray from "@homer.utility/validator.isarray";
import isTransferable from "@homer.utility/validator.istransferable";
import isFunction from "@homer.utility/validator.isfunction";
import Uuid from "@homer.utility/uuid";
import create from "./create.js";

const executions = {};

/**
 * Class Task
 */
class Task {
    #worker;
    #onExecute;

    /**
     * Constructor
     *
     * @param {Function} task
     * @param {Function} onExecute
     */
    constructor(task, onExecute) {
        const worker = new Worker(
            URL.createObjectURL(
                new Blob([create(task)], {
                    type: "application/javascript",
                }),
            ),
        );

        worker.onmessage = (message) => {
            const uuid = isArray(message.data) ? message.data[0] : null;
            const execution = uuid ? executions[uuid] : null;

            if (!uuid || !execution) {
                return;
            }

            const type = message.data[1];
            const data = message.data[2];

            if (type === 2) {
                execution.resolve(data);
            } else if (type === 1) {
                execution.reject(data);
            } else if (type === 0) {
                execution.reject(new globalThis[data.type](data.message));
            }

            delete executions[uuid];
        };

        this.#worker = worker;
        this.#onExecute = isFunction(onExecute) ? onExecute : null;

        return this;
    }

    /**
     * Execute the task with the given arguments
     *
     * @param {...*} parameter
     *
     * @returns {Promise}
     */
    execute(...parameter) {
        const uuid = Uuid.generate();

        return Object.defineProperties(
            new Promise((resolve, reject) => {
                executions[uuid] = { resolve, reject };

                if (this.#onExecute) {
                    this.#onExecute(parameter);
                }

                this.#worker.postMessage([uuid, "execute", parameter], parameter.filter(isTransferable));
            }),
            {
                uuid: {
                    get: () => uuid,
                },
                signal: {
                    value: (signal, additional) => {
                        this.#worker.postMessage([uuid, "signal", signal, additional]);
                    },
                },
            },
        );
    }
}

export default Task;
